import { c as _c } from "react/compiler-runtime";
import { LinearProgress, Stack } from '@mui/material';
import { ComponentProps, useState } from 'react';
import { DocumentLoader } from '@/components/progress/DocumentLoader';
import { PDFViewerSlots } from '@/modules/pdf/PDFViewer/PDFViewer.types';
import { COLORS } from '@/styles/tokens/colors';
export function FormDocumentLoader(t0) {
  const $ = _c(14);
  const {
    progress,
    ready,
    onComplete
  } = t0;
  const [downloadProgress, setDownloadProgress] = useState(progress);
  if (progress !== undefined && (downloadProgress === undefined || progress > downloadProgress)) {
    setDownloadProgress(progress);
  }
  let t1;
  if ($[0] !== onComplete || $[1] !== ready) {
    t1 = <DocumentLoader ready={ready} onComplete={onComplete} />;
    $[0] = onComplete;
    $[1] = ready;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = ready ? 100 : downloadProgress ?? 0;
  const t3 = ready ? 100 : downloadProgress;
  const t4 = ready ? 0 : 1;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      bgcolor: "#FF594E",
      transitionDuration: "300ms"
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      transition: "none",
      "& .MuiLinearProgress-bar": {
        animation: "none",
        transition: "none"
      }
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4) {
    t7 = {
      width: 208,
      height: 3,
      borderRadius: 1,
      bgcolor: COLORS.GRAY[200],
      opacity: t4,
      transition: "opacity 450ms ease-in",
      "& .MuiLinearProgress-bar": t5,
      "@media (prefers-reduced-motion: reduce)": t6
    };
    $[5] = t4;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t7) {
    t8 = <LinearProgress aria-label="Downloading source document" variant="determinate" value={t2} aria-valuenow={t3} sx={t7} />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t8) {
    t9 = <Stack height="100%" alignItems="center" justifyContent="center"><Stack alignItems="center">{t1}{t8}</Stack></Stack>;
    $[11] = t1;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
export const formDocumentLoadingSlots = {
  LoadingExternal: FormDocumentLoader,
  DocumentLoading: FormDocumentLoader
} satisfies PDFViewerSlots;